import React from 'react';
import Helmet from 'react-helmet';
import _ from 'lodash';
import ClipLoader from 'react-spinners/ClipLoader';

import { PartnerNaviList } from '../components/list/PartnerNaviList';
import SessionStorageService from '../services/utilities/SessionStorageService';
import {
  API_FLAG,
  HEADER_CONSTANTS,
  ADMIN_STATUS_LIST,
} from '../utilities/constants';
import _masterSlideLoader from '../utilities/masterSlideLoader';
import dialogLoader from '../utilities/dialogLoader';
import {
  getPartnerCompanyInfo,
  propsToCompanyId,
} from '../utilities/partnerCompanyConfirmUtil';
import { MasterPageHeader } from '../components/PageHeader';
import { PartnerCompanyBranchForm } from '../components/PartnerCompanyBranchForm';
import PartnerCompanyBranchService from '../services/PartnerCompanyBranch';
import Confirmation from '../components/modals/common/Confirmation';
import { messageUtility } from '../utilities/messageUtility';
import { PartnerCompanyBranchDropdown } from '../components/PartnerCompanyBranchDropdown';
import { onceAsyncRequest } from '../utilities/commonUtil';
import { FormInformationDialog } from '../components/FormInformationDialog';
import { CompanyService } from '../services/Companies';
import UsersApi from '../services/users/UsersApi';
import LocalStorageService from '../services/utilities/LocalStorageService';
import BuildeeManagerRequestApi from '../services/buildeeManagerRequest/BuildeeManagerRequestApi';
import { isLoginUserPartner } from '../utilities/roleUtility';
import PartnerCompanyBranchDescription from '../components/PartnerCompanyBranchDescription';
import { isOneOwnerCompany } from '../utilities/partnerCompanyUtil';

const modalList = {
  SUSPEND_COMPANY: 'suspend_partner_company_branch',
  RESTORE_COMPANY: 'restore_partner_company_branch',
};
const IS_BUILDEE_MANAGER = 1;
const ADMIN_PERMISSIONS = {
  FULL_PERMISSION: 1,
  ONLY_UPDATE: 2,
  ONLY_VIEW: 3,
};

export class PartnerCompanyBranchPreview extends React.Component {
  constructor(props) {
    super(props);

    this.initSelectedCompany();

    this.isOwnCompany =
      Number(
        SessionStorageService.getSessionPartnerCompanyIdOfPrimeCompany()
      ) === this.selectedCompanyId;

    this.state = {
      selectedCompanyName: '',
      formValues: {},
      isLoading: false,
      hasNoData: true,
      selectedModalId: '',
      adminStatus: null,
      buildeeManagerGrantRequestInfo: {
        request_user_name: '',
        target_user_name: '',
      },
      adminPermission: ADMIN_PERMISSIONS.ONLY_VIEW,
      expirationCompany: {},
      isOneOwnerCompany: undefined,
    };
    this.defaultFormValues = {
      name: '', // 会社名
      kana: '', // 支店名ふりがな
      postal_code: '', // 郵便番号
      prefectures_code_id: '', // 都道府県
      city_name: '', // 市区町村
      street_number: '', // 丁目・番地
      building_name: '', // 建物名・部屋番号等
      tel: '', // 電話番号
      fax: '', // FAX
    };
    this.defaultParams = {
      block_flags: [false, true],
      order: 'block_flag_asc',
    };
  }

  getExpiration = async () => {
    await CompanyService.expirations(this.selectedCompanyId).then(response => {
      if (!response.result) {
        return;
      }
      this.setState({
        expirationCompany: {
          ...this.state.expirationCompany,
          ...response.data.entities.company.expiration,
        },
      });
    });
  };

  async componentDidMount() {
    const selectedPartnerCompanyBranchId = _.get(
      this.props,
      'view.state.selectedPartnerCompanyBranchId'
    );
    if (selectedPartnerCompanyBranchId) {
      this.getPartnerCompanyBranch(selectedPartnerCompanyBranchId).then(
        response => {
          if (response) {
            this.initForm(response);
          } else {
            this.showErrorDialog();
          }
        }
      );
    } else {
      this.getPartnerCompanyBranchList();
    }
    this.setCompanyName();
    this.getExpiration();
    this.setAdminStatus();
  }

  setAdminStatus = async () => {
    const result = await this.checkPermissionBuildeeManager();
    const ownCompany =
      Number(
        SessionStorageService.getSessionPartnerCompanyIdOfPrimeCompany()
      ) === this.selectedCompanyId;
    let adminStatus = ADMIN_STATUS_LIST.IS_NOT_CURRENT_ADMIN;
    if (result) {
      const userId = LocalStorageService.getUserId();
      const userBuildeeManager = _.filter(
        result,
        user => Number(userId) === user.user_id
      );
      adminStatus =
        ownCompany && !_.isEmpty(userBuildeeManager)
          ? ADMIN_STATUS_LIST.IS_CURRENT_ADMIN
          : ADMIN_STATUS_LIST.IS_NOT_CURRENT_ADMIN;
      this.setState({ adminStatus });
    } else {
      await this.checkGrantRequestBuildeeManager();
    }

    let adminPermission = ADMIN_PERMISSIONS.ONLY_VIEW;
    if (adminStatus == ADMIN_STATUS_LIST.IS_CURRENT_ADMIN) {
      adminPermission = ADMIN_PERMISSIONS.FULL_PERMISSION;
    } else if (ownCompany) {
      adminPermission = ADMIN_PERMISSIONS.ONLY_UPDATE;
    }
    this.setState({ adminPermission });
  };

  checkPermissionBuildeeManager = async () => {
    const { data, result } = await UsersApi.fetchCompanyUserPermissions(
      this.selectedCompanyId,
      { buildee_manager_flg: IS_BUILDEE_MANAGER }
    );
    if (!result) {
      return null;
    }
    const companyUserPermissions = _.get(
      data,
      'entities.company_user_permissions'
    );
    return !_.isEmpty(companyUserPermissions) ? companyUserPermissions : null;
  };

  checkGrantRequestBuildeeManager = async () => {
    if (!this.isOwnCompany) {
      return;
    }
    const {
      data,
      result,
    } = await BuildeeManagerRequestApi.fetchBuildeeBanagerGrantRequests(
      this.selectedCompanyId,
      isLoginUserPartner() ? SessionStorageService.getCompanyBranchId() : 0
    );
    this.setState({ adminStatus: ADMIN_STATUS_LIST.NOT_SETTING });
    if (!result) {
      return;
    }
    if (data.total > 0) {
      for (let req of data.entities.buildee_manager_grant_requests) {
        if (_.isNil(req.approval_flg)) {
          this.setState({
            adminStatus: ADMIN_STATUS_LIST.WAITING_CONFIRM,
            buildeeManagerGrantRequestInfo: {
              request_user_name: req.request_user_name,
              target_user_name: req.target_user_name,
            },
          });
          break;
        }
      }
    }
  };

  initSelectedCompany = () => {
    this.selectedCompanyId = propsToCompanyId(this.props);
  };

  handleSelectPartnerCompanyBranch = id => {
    this.setState(
      {
        isLoading: true,
      },
      async () => {
        this.initForm(await this.getPartnerCompanyBranch(id));
        this.setState({
          isLoading: false,
        });
      }
    );
  };

  getPartnerCompanyBranchList = () => {
    this.setState(
      {
        isLoading: true,
      },
      () => {
        PartnerCompanyBranchService.partnerCompanyBranchList(
          this.selectedCompanyId,
          this.defaultParams
        ).then(response => {
          if (response.result && _.has(response, 'data.entities')) {
            if (_.has(response, 'data.entities.partner_company_branches')) {
              this.initForm(response.data.entities.partner_company_branches[0]);
            }
            this.setState({
              isLoading: false,
              hasNoData: _.isEmpty(
                response.data.entities.partner_company_branches
              ),
            });
          }
        });
      }
    );
  };

  showErrorDialog = () => {
    dialogLoader.show(FormInformationDialog, {
      title: 'エラーが発生しました',
      message:
        'エラーが発生しました。会社情報を開きなおし、再度操作を行ってください。',
      onClose: () => {
        dialogLoader.close();
        _masterSlideLoader.show('CompanyPreview', {
          state: {
            id: this.selectedCompanyId,
          },
        });
      },
    });
  };

  handleCloseModal = () => {
    this.setState({
      selectedModalId: '',
    });
  };

  handleOpenModal = selectedModalId => {
    this.setState({ selectedModalId });
  };

  setCompanyName = () => {
    this.setState(
      {
        isLoading: true,
      },
      async () => {
        const { company, result, companyName } = await getPartnerCompanyInfo(
          this.selectedCompanyId
        );
        let selectedCompanyName = '';
        let oneOwnerCompany = false;
        if (result) {
          selectedCompanyName = companyName;
          oneOwnerCompany = isOneOwnerCompany(company.one_owner_flag);
        }
        this.setState({
          selectedCompanyName,
          isOneOwnerCompany: oneOwnerCompany,
          isLoading: false,
        });
      }
    );
  };

  initForm = companyBranchData => {
    if (companyBranchData) {
      const { block_flag: blockFlag, name } = companyBranchData;
      this.setState({
        formValues: {
          ...companyBranchData,
          formattedName: blockFlag ? `${name}（停止中）` : name,
        },
        hasNoData: false,
      });
    } else {
      this.setState({
        formValues: this.defaultFormValues,
      });
    }
  };

  onCreateNewButton = () => {
    _masterSlideLoader.show('PartnerCompanyBranchNew', {
      state: {
        id: this.selectedCompanyId,
      },
    });
  };

  onClickEditButton = id => {
    SessionStorageService.setSelectedPartnerCompanyBranchId(id);

    _masterSlideLoader.show('PartnerCompanyBranchEdit', {
      state: {
        id: this.selectedCompanyId,
      },
    });
  };

  getPartnerCompanyBranch = async id => {
    if (id) {
      const { data } = await PartnerCompanyBranchService.show(
        this.selectedCompanyId,
        id
      );
      return _.get(data, 'entities.partner_company_branch');
    }
  };

  onUpdateCompanyStatus = onceAsyncRequest(async block_flag => {
    this.setState({ isLoading: true });
    const response = await PartnerCompanyBranchService.updatePartnerCompanyBranch(
      this.selectedCompanyId,
      this.state.formValues.id,
      { block_flag }
    );
    if (
      response.result &&
      _.has(response, 'data.entities.partner_company_branch')
    ) {
      this.initForm(response.data.entities.partner_company_branch);
    }
    this.setState({ isLoading: false });

    this.handleCloseModal();

    if ([400, 422].includes(response.status)) {
      let message = messageUtility.getMessage('E-001-433');
      const errorMessageOneOwnerCompany = messageUtility.getMessage(
        'E-001-434'
      );
      if (
        _.isEqual(_.get(response, 'data.message'), errorMessageOneOwnerCompany)
      ) {
        message = _.get(response, 'data.message');
      }
      this.showErrorCreateDialog(message);
    }
  });

  redirectToAgencyCompanies = () => {
    _masterSlideLoader.show('AgencyCompanies', {
      state: {},
    });
  };

  showErrorCreateDialog = message => {
    dialogLoader.show(FormInformationDialog, {
      title: messageUtility.getMessage('E-001-402'),
      message,
      onClose: () => {
        dialogLoader.close();
        this.updatingFalg = false;
        _masterSlideLoader.show('CompanyPreview', {
          state: {
            id: this.selectedCompanyId,
          },
        });
      },
    });
  };

  render() {
    const {
      selectedCompanyName,
      isLoading,
      hasNoData,
      formValues,
      selectedModalId,
      adminStatus,
      buildeeManagerGrantRequestInfo,
      adminPermission,
      isOneOwnerCompany,
    } = this.state;

    const title = `${selectedCompanyName} 会社情報`;
    const isSuspended = formValues.block_flag === Boolean(API_FLAG.On);
    const btnDisabled = !_.has(formValues, 'id');
    const fullPermission =
      adminPermission === ADMIN_PERMISSIONS.FULL_PERMISSION;
    const onlyUpdate = adminPermission === ADMIN_PERMISSIONS.ONLY_UPDATE;
    const onlyView = adminPermission === ADMIN_PERMISSIONS.ONLY_VIEW;
    const changePartnerCompanyBranchDropdownOptionDisplay = options => {
      const formatName = option => {
        const { block_flag: blockFlag, name } = option;
        const statusBlocked = '（停止中）';

        return blockFlag && !name.includes(statusBlocked)
          ? `${name}${statusBlocked}`
          : name;
      };
      return _.map(options, option => ({
        ...option,
        name: formatName(option),
      }));
    };

    return (
      <div id='slide-view' className='contruction-slide-view show'>
        <Helmet>
          <title>
            {HEADER_CONSTANTS.title} - {title}
          </title>
        </Helmet>
        <div className='contruction-slide-view__view'>
          <MasterPageHeader
            title={title}
            loaderComponent={<ClipLoader size={20} color={'#EDB715'} />}
            loaded={!isLoading}
            onClose={() => _masterSlideLoader.close()}
          />
          <div className='contruction-slide-view__body contruction-slide-view__body--height-fix'>
            <div className='contruction-detail-view'>
              <div className='contruction-detail-view__sidemenu'>
                <PartnerNaviList
                  isSelectedPartnerBranchInfomation={true}
                  selectedPartnerCompanyId={this.selectedCompanyId}
                  expirationCompany={this.state.expirationCompany}
                />
              </div>
              {!isLoading && (
                <div className='contruction-detail-view__body contruction-detail-view__body--fixed PartnerCompanyBranchPreview'>
                  {!this.isOwnCompany && (
                    <div style={{ padding: '10px 20px 0' }}>
                      <button
                        className='btn-text--sm'
                        onClick={this.redirectToAgencyCompanies}
                      >
                        <i className='i-back--blue i-2x vertical-middle' />
                        代行先一覧
                      </button>
                    </div>
                  )}
                  {(!hasNoData || fullPermission) && (
                    <React.Fragment>
                      <div className='PartnerCompanyBranchPreview__header'>
                        {hasNoData ? (
                          fullPermission && (
                            <span className='construction-detail-view__button'>
                              <button
                                className={
                                  isOneOwnerCompany ? 'btn--disabled' : 'btn'
                                }
                                onClick={this.onCreateNewButton}
                                disabled={isOneOwnerCompany}
                              >
                                支店新規作成
                              </button>
                            </span>
                          )
                        ) : (
                          <React.Fragment>
                            <PartnerCompanyBranchDropdown
                              selectedCompanyId={this.selectedCompanyId}
                              selectedPartnerCompanyBranchId={formValues.id}
                              previewValue={formValues.formattedName}
                              onSelect={this.handleSelectPartnerCompanyBranch}
                              params={this.defaultParams}
                              isPartnerCompanyBranchPreview={true}
                              transformOptions={
                                changePartnerCompanyBranchDropdownOptionDisplay
                              }
                              responseParseKeys={[
                                {
                                  keyName: 'block_flag',
                                  defaultValue: false,
                                },
                              ]}
                            />
                            {isSuspended && fullPermission && (
                              <span className='construction-detail-view__button'>
                                <button
                                  className={
                                    btnDisabled || isOneOwnerCompany
                                      ? 'btn--disabled'
                                      : 'btn--effective'
                                  }
                                  onClick={() => {
                                    this.handleOpenModal(
                                      modalList.RESTORE_COMPANY
                                    );
                                  }}
                                  disabled={btnDisabled || isOneOwnerCompany}
                                >
                                  支店の復旧
                                </button>
                              </span>
                            )}
                            <span className='construction-detail-view__button'>
                              {!isSuspended && (fullPermission || onlyUpdate) && (
                                <button
                                  className={
                                    btnDisabled ? 'btn btn--disabled' : 'btn'
                                  }
                                  onClick={() =>
                                    this.onClickEditButton(formValues.id)
                                  }
                                  disabled={btnDisabled}
                                >
                                  この支店を編集
                                </button>
                              )}
                            </span>
                            <span className='construction-detail-view__button'>
                              {!isSuspended && fullPermission && (
                                <button
                                  className={
                                    btnDisabled
                                      ? 'btn--negative btn--disabled'
                                      : 'btn--negative'
                                  }
                                  onClick={() =>
                                    this.handleOpenModal(
                                      modalList.SUSPEND_COMPANY
                                    )
                                  }
                                  disabled={btnDisabled}
                                >
                                  この支店を停止
                                </button>
                              )}
                            </span>
                            <span className='construction-detail-view__button construction-detail-view__button--end-item'>
                              {fullPermission && (
                                <button
                                  className={
                                    isOneOwnerCompany ? 'btn--disabled' : 'btn'
                                  }
                                  onClick={this.onCreateNewButton}
                                  disabled={isOneOwnerCompany}
                                >
                                  支店新規作成
                                </button>
                              )}
                            </span>
                          </React.Fragment>
                        )}
                      </div>
                      <div className='contruction-detail-view__bar' />
                    </React.Fragment>
                  )}
                  <div className='contruction-detail-view__main contruction-detail-view__main--fixed'>
                    <PartnerCompanyBranchDescription
                      hasNodata={hasNoData}
                      isSuspended={isSuspended}
                      adminStatus={adminStatus}
                      otherCompany={onlyView}
                      buildeeManagerGrantRequestInfo={
                        buildeeManagerGrantRequestInfo
                      }
                      isOneOwnerCompany={isOneOwnerCompany}
                      selectedCompanyId={this.selectedCompanyId}
                    />
                    {!hasNoData && (
                      <PartnerCompanyBranchForm
                        readOnly={true}
                        values={formValues}
                        events={{}}
                      />
                    )}
                  </div>
                </div>
              )}
            </div>
            {isLoading && <div className='indicator' />}
          </div>
        </div>
        <Confirmation
          title='支店の停止'
          rootClassName='PartnerCompanyBranchPreview__dialog'
          visible={selectedModalId === modalList.SUSPEND_COMPANY}
          message={
            <React.Fragment>
              <p>
                支店の停止を行うと、その支店に紐づけられていたユーザーおよび作業員の支店情報は自動的に解除されます。
              </p>
              <p>
                {formValues.name}
                支店を停止してよろしいですか？
              </p>
            </React.Fragment>
          }
          confirmButtonText='支店を停止'
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          onConfirm={() => this.onUpdateCompanyStatus(true)}
          onCancel={this.handleCloseModal}
          isNegative={true}
        />

        <Confirmation
          title='支店の復旧'
          rootClassName='PartnerCompanyBranchPreview__dialog'
          visible={selectedModalId === modalList.RESTORE_COMPANY}
          message={
            <React.Fragment>
              <p>{formValues.name}支店を復旧します。</p>
              <p>
                この支店に紐づけられていたユーザーおよび作業員の支店情報は、停止時に削除されています。
              </p>
              <p>
                必要に応じて再度ユーザーおよび作業員の支店を設定してください。
              </p>
            </React.Fragment>
          }
          confirmButtonText='支店を復旧'
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          onConfirm={() => this.onUpdateCompanyStatus(false)}
          onCancel={this.handleCloseModal}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/PartnerCompanyBranchPreview.jsx